import { Address, NetworkEnum } from '@1inch/fusion-sdk';
const TrueERC20 = new Address('0xda0000d4000015a526378bb6fafc650cea5966f8');
const ZKTrueERC20 = new Address('0xd66097c27eb8dee404bac235737932260edc6f3b');
export const TRUE_ERC20 = {
    [NetworkEnum.ETHEREUM]: TrueERC20,
    [NetworkEnum.POLYGON]: TrueERC20,
    [NetworkEnum.OPTIMISM]: TrueERC20,
    [NetworkEnum.BINANCE]: TrueERC20,
    [NetworkEnum.AVALANCHE]: TrueERC20,
    [NetworkEnum.COINBASE]: TrueERC20,
    [NetworkEnum.FANTOM]: TrueERC20,
    [NetworkEnum.GNOSIS]: TrueERC20,
    [NetworkEnum.ARBITRUM]: TrueERC20,
    [NetworkEnum.ZKSYNC]: ZKTrueERC20,
    [NetworkEnum.LINEA]: TrueERC20
};
const ESCROW_FACTORY_ADDRESS = new Address('0xa7bcb4eac8964306f9e3764f67db6a7af6ddf99a');
const ESCROW_ZK_FACTORY_ADDRESS = new Address('0x584aeab186d81dbb52a8a14820c573480c3d4773');
const ESCROW_SRC_IMPLEMENTATION_ADDRESS = new Address('0xcd70bf33cfe59759851db21c83ea47b6b83bef6a');
const ESCROW_ZK_SRC_IMPLEMENTATION_ADDRESS = new Address('0xddc60c7babfc55d8030f51910b157e179f7a41fc');
const ESCROW_DST_IMPLEMENTATION_ADDRESS = new Address('0x9c3e06659f1c34f930ce97fcbce6e04ae88e535b');
const ESCROW_ZK_DST_IMPLEMENTATION_ADDRESS = new Address('0xdc4ccc2fc2475d0ed3fddd563c44f2bf6a3900c9');
export const ESCROW_SRC_IMPLEMENTATION = {
    [NetworkEnum.ETHEREUM]: ESCROW_SRC_IMPLEMENTATION_ADDRESS,
    [NetworkEnum.POLYGON]: ESCROW_SRC_IMPLEMENTATION_ADDRESS,
    [NetworkEnum.OPTIMISM]: ESCROW_SRC_IMPLEMENTATION_ADDRESS,
    [NetworkEnum.BINANCE]: ESCROW_SRC_IMPLEMENTATION_ADDRESS,
    [NetworkEnum.AVALANCHE]: ESCROW_SRC_IMPLEMENTATION_ADDRESS,
    [NetworkEnum.COINBASE]: ESCROW_SRC_IMPLEMENTATION_ADDRESS,
    [NetworkEnum.FANTOM]: ESCROW_SRC_IMPLEMENTATION_ADDRESS,
    [NetworkEnum.GNOSIS]: ESCROW_SRC_IMPLEMENTATION_ADDRESS,
    [NetworkEnum.ARBITRUM]: ESCROW_SRC_IMPLEMENTATION_ADDRESS,
    [NetworkEnum.ZKSYNC]: ESCROW_ZK_SRC_IMPLEMENTATION_ADDRESS,
    [NetworkEnum.LINEA]: ESCROW_SRC_IMPLEMENTATION_ADDRESS
};
export const ESCROW_DST_IMPLEMENTATION = {
    [NetworkEnum.ETHEREUM]: ESCROW_DST_IMPLEMENTATION_ADDRESS,
    [NetworkEnum.POLYGON]: ESCROW_DST_IMPLEMENTATION_ADDRESS,
    [NetworkEnum.OPTIMISM]: ESCROW_DST_IMPLEMENTATION_ADDRESS,
    [NetworkEnum.BINANCE]: ESCROW_DST_IMPLEMENTATION_ADDRESS,
    [NetworkEnum.AVALANCHE]: ESCROW_DST_IMPLEMENTATION_ADDRESS,
    [NetworkEnum.COINBASE]: ESCROW_DST_IMPLEMENTATION_ADDRESS,
    [NetworkEnum.FANTOM]: ESCROW_DST_IMPLEMENTATION_ADDRESS,
    [NetworkEnum.GNOSIS]: ESCROW_DST_IMPLEMENTATION_ADDRESS,
    [NetworkEnum.ARBITRUM]: ESCROW_DST_IMPLEMENTATION_ADDRESS,
    [NetworkEnum.ZKSYNC]: ESCROW_ZK_DST_IMPLEMENTATION_ADDRESS,
    [NetworkEnum.LINEA]: ESCROW_DST_IMPLEMENTATION_ADDRESS
};
export const ESCROW_FACTORY = {
    [NetworkEnum.ETHEREUM]: ESCROW_FACTORY_ADDRESS,
    [NetworkEnum.POLYGON]: ESCROW_FACTORY_ADDRESS,
    [NetworkEnum.OPTIMISM]: ESCROW_FACTORY_ADDRESS,
    [NetworkEnum.BINANCE]: ESCROW_FACTORY_ADDRESS,
    [NetworkEnum.AVALANCHE]: ESCROW_FACTORY_ADDRESS,
    [NetworkEnum.COINBASE]: ESCROW_FACTORY_ADDRESS,
    [NetworkEnum.FANTOM]: ESCROW_FACTORY_ADDRESS,
    [NetworkEnum.GNOSIS]: ESCROW_FACTORY_ADDRESS,
    [NetworkEnum.ARBITRUM]: ESCROW_FACTORY_ADDRESS,
    [NetworkEnum.ZKSYNC]: ESCROW_ZK_FACTORY_ADDRESS,
    [NetworkEnum.LINEA]: ESCROW_FACTORY_ADDRESS
};
//# sourceMappingURL=deployments.js.map